import { sanityOriginClient } from './client';
import {
  predictedLineupsPageDraftQuery,
  predictedLineupsPageQuery
} from './queries';
import type { SanityPredictedLineupsPage } from './types';

/** Must match PREDICTED_LINEUPS_SINGLETON_ID in sanity/schemaTypes/predictedLineupsPage.ts. */
export const PREDICTED_LINEUPS_SINGLETON_ID = 'predictedLineupsPage';

// Replaced the WordPress article at /premier-league-predicted-lineups, which
// next.config.js 301s here along with the old /predicted-lineups-beta route.
export const PREDICTED_LINEUPS_PATH = '/predicted-lineups';

export const getPredictedLineupsPage =
  async (): Promise<SanityPredictedLineupsPage | null> => {
    const page = await sanityOriginClient.fetch<SanityPredictedLineupsPage | null>(
      predictedLineupsPageQuery,
      { id: PREDICTED_LINEUPS_SINGLETON_ID }
    );
    return page ?? null;
  };

/**
 * Draft-or-published read, premium club sections included, for the editor
 * preview route only.
 */
export const getPredictedLineupsPageDraft =
  async (): Promise<SanityPredictedLineupsPage | null> => {
    const page = await sanityOriginClient
      .withConfig({ perspective: 'drafts' })
      .fetch<SanityPredictedLineupsPage | null>(predictedLineupsPageDraftQuery, {
        id: PREDICTED_LINEUPS_SINGLETON_ID
      });
    return page ?? null;
  };
